import store from '@/store'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const roles = store.getters && store.getters.roles

    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value

      const hasRole = roles.some(role => {
        return permissionRoles.includes(role)
      })

      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el)
      } else {
        roles.filter(role => permissionRoles.includes(role))
          .map(r => `data-role-${r.toLowerCase()}`)
          .forEach(d => {
            el.setAttribute(d, '')
          })
      }
      if (permissionRoles.length === 1 && permissionRoles.includes('DEV') && !store.getters.devMode) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`need roles! Like v-role="['admin','editor']"`)
    }
  }
}



// WEBPACK FOOTER //
// ./src/directive/permission/role.js